import { render } from "./Parallax.vue?vue&type=template&id=f44a3806&scoped=true"
import script from "./Parallax.vue?vue&type=script&lang=js"
export * from "./Parallax.vue?vue&type=script&lang=js"

import "./Parallax.vue?vue&type=style&index=0&id=f44a3806&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44a3806"]])

export default __exports__